import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API, scrollToId } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/Marquee";
import { Shop } from "@/components/home/Shop";
import { BundlePromo } from "@/components/home/BundlePromo";
import { Features } from "@/components/home/Features";
import { useSeo } from "@/lib/seo";

export default function Home() {
  useSeo({
    title: "Insane Circle — Funky Printed Socks Made in India",
    description: "Shop Insane Circle's loud, unisex printed socks made in India: Burning Fire and Insane Heroes. 299 Rs a pair or any 5 pairs for 999 Rs, ordered on WhatsApp.",
    path: "/",
  });
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState("all");
  const { hash } = useLocation();
  const { sync } = useCart();

  useEffect(() => {
    const load = async () => {
      try {
        const [c, p] = await Promise.all([axios.get(`${API}/categories`), axios.get(`${API}/products`)]);
        setCategories(Array.isArray(c.data) ? c.data : []);
        const list = Array.isArray(p.data) ? p.data : [];
        setProducts(list);
        if (list.length) sync(list);
      } catch {
        setCategories([]);
        setProducts([]);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!hash || !products.length) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 300);
    return () => clearTimeout(t);
  }, [hash, products.length]);

  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Shop categories={categories} products={products} active={active} setActive={setActive} />
      <BundlePromo />
      <Features />
    </div>
  );
}
